import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link, FormattedMessage } from "gatsby-plugin-intl";
import navItems from "./navItems";
import DropDown from "./DropDown";

const Navigation = ({ className }) => {
  return (
    <ul
      className={classNames(
        "navigation flex rtl:flex-row-reverse items-center h-full",
        className
      )}
    >
      {navItems.map(
        ({
          i18nLabel,
          path,
          withDropDown,
          dropdownType,
          className: itemClassName,
          items,
          onClick,
        }) => (
          <li
            key={i18nLabel}
            className="ltr:mr-6 rtl:ml-6 xl:ltr:mr-10 xl:rtl:ml-10"
          >
            {!withDropDown ? (
              <Link
                className="text-black hover:text-primary"
                to={path}
                onClick={onClick}
              >
                <FormattedMessage id={`navigation.${i18nLabel}`} />
              </Link>
            ) : (
              <DropDown
                type={dropdownType}
                to={path}
                className={classNames(
                  "text-black hover:text-primary",
                  itemClassName
                )}
                items={items}
              >
                <FormattedMessage id={`navigation.${i18nLabel}`} />
              </DropDown>
            )}
          </li>
        )
      )}
    </ul>
  );
};

Navigation.propTypes = {
  className: PropTypes.string,
};

export default Navigation;
